<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="productDetailGroupInfo.groups"
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column prop="groupId" :label="$t('productDetailGroup.id')" align="center" />
        <el-table-column :label="$t('productDetailGroup.productImage')" align="center">
          <template #default="{row}">
            <div style="position: relative; display: inline-block;">
              <el-image
                width="50"
                height="50"
                style="border-radius: 10px;"
                :src="row.coverPhoto"
                v-if="row.coverPhoto"
              />
              <el-image
                width="50"
                height="50"
                style="border-radius: 10px;"
                src="/img/noPhoto.jpg"
                v-else
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="prodName" :label="$t('productDetailGroup.productName')" align="center" />
        <el-table-column prop="userCount" :label="$t('productDetailGroup.groupCount')" align="center" />
        <el-table-column :label="$t('productDetailGroup.groupPrice')" align="center">
          <template #default="{row}">￥{{row.groupPrice}}</template>
        </el-table-column>
        <el-table-column :label="$t('productDetailGroup.singlePrice')" align="center">
          <template #default="{row}">￥{{row.price}}</template>
        </el-table-column>
        <el-table-column :label="$t('productDetailGroup.status')" align="center">
          <template #default="{row}">{{row.state == '1001'?'启用':'停用'}}</template>
        </el-table-column>
        <el-table-column :label="$t('productDetailGroup.validity')" align="center">
          <template #default="{row}">{{row.startTime}}~{{row.endTime}}</template>
        </el-table-column>
        <el-table-column :label="$t('productDetailGroup.rebateFlag')" align="center">
          <template #default="{row}">{{row.rebateFlag == 'Y'?'是':'否'}}</template>
        </el-table-column>
        <el-table-column :label="$t('productDetailGroup.leaderRebate')" align="center">
          <template #default="{row}">{{row.rebate}}%</template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listProductGroup } from '@/api/goods/productDetailApi'

export default {
  name: 'ProductDetailGroup',
  data() {
    return {
      productDetailGroupInfo: {
        groups: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailGroupInfo.productId = params.productId
      this.loadProductDetailGroupData()
    },
    async loadProductDetailGroupData() {
      const res = await listProductGroup({
          productId: this.productDetailGroupInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId()
      })

      this.productDetailGroupInfo.groups = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailGroupData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>